<div class="d-block mb-3">
  <span class="fw-regular" [ngClass]="required && editMode ? 'required' : ''">{{ label }}</span>
  @if (!required && editMode) {
    <span class="form-field-optional text-secondary ms-1">(optional)</span>
  }
</div>
@if (editMode) {
  <!-- Always visible for the whole time editMode is true - never gated by any inner/per-field
       edit toggle, matching consignments' own outer search block
       (`consignment-carrier-details.component.html` lines 1-16). -->
  <div class="row mb-3">
    <div class="col">
      <ng-content></ng-content>
    </div>
  </div>
}
@if (entity) {
  <div class="card form-group">
    <div class="card-body p-4">
      @if (richAddress) {
        <!-- Container operator only (see class doc): full read-only Carrier field grid, matching
             `consignment-carrier-details.component.html`'s Name/EORI/address/Telephone/Email layout. -->
        <div class="row gy-3 mb-3">
          <div class="col-12 col-lg-8 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Name" [includeMargin]="false" [value]="entity.name"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="EORI number" [includeMargin]="false" [value]="entity.customsId"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
        </div>
        <div class="row gy-3 mb-3">
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Street" [includeMargin]="false" [value]="entity.address?.street"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Number" [includeMargin]="false" [value]="entity.address?.number"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Post office box" [includeMargin]="false" [value]="entity.address?.poBox"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
        </div>
        <div class="row gy-3 mb-3">
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Postal code" [includeMargin]="false" [value]="entity.address?.postCode"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="City" [includeMargin]="false" [value]="entity.address?.city"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Region" [includeMargin]="false" [value]="entity.address?.subDivision"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
        </div>
        <div class="row gy-3">
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Country" [includeMargin]="false" [value]="entity.address?.country"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Telephone" [includeMargin]="false" [value]="richAddressTelephone"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Email address" [includeMargin]="false" [value]="richAddressEmail"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
        </div>
      } @else if (basicAddress) {
        <!-- Release-to party only (see class doc): smaller read-only address grid sized to what
             `ApiCustomer.customerData` genuinely carries (name/address/zipCode/city) - no
             number/PO box/region/country/telephone/email, those are not present on this data. -->
        <div class="row gy-3 mb-3">
          <div class="col-12 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Name" [includeMargin]="false" [value]="entity.name"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
        </div>
        <div class="row gy-3">
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Address" [includeMargin]="false" [value]="entity.address"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Postal code" [includeMargin]="false" [value]="entity.zipCode"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="City" [includeMargin]="false" [value]="entity.city"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
        </div>
      } @else if (eanGrid) {
        <!-- Inland operator only (see class doc): two-field read-only grid sized to what the
             generated `InlandOperator` model actually carries (`name`/`ean`) - no address, no
             richer variant applies. EAN code gets its own labeled field per the founder's request
             rather than staying buried inside the single formatted line. -->
        <div class="row gy-3">
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="Name" [includeMargin]="false" [value]="entity.name"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
          <div class="col-12 col-lg-4 d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field label="EAN code" [includeMargin]="false" [value]="entity.ean"
                            [editMode]="false" [renderOptional]="false"></app-form-field>
          </div>
        </div>
      } @else {
        <div class="row">
          <div class="col d-flex flex-column align-items-stretch justify-content-center">
            <app-form-field [includeMargin]="false" [value]="entity" [formatter]="formatter"
                            [renderOptional]="false" [editMode]="false"></app-form-field>
          </div>
        </div>
      }
    </div>
  </div>
} @else if (!editMode) {
  <span class="d-block mb-3 text-muted">Unknown</span>
}
